<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="handleBatchDelete">{{ $t('批量删除') }}</el-button>
      <el-button @click.native="handleBatchPass">{{ $t('批量审核') }}</el-button>

    </template>

    <template #search-form>
      <el-form-item :label="$t('认证者编号')">
        <el-input :placeholder="$t('认证者编号')" v-model="searchForm.usernum" clearable/>
      </el-form-item>

      <el-form-item :label="$t('认证者姓名')">
        <el-input :placeholder="$t('认证者姓名')" v-model="searchForm.username" clearable/>
      </el-form-item>

      <el-form-item :label="$t('手机号')">
        <el-input :placeholder="$t('手机号')" v-model="searchForm.phone" clearable/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <template #tab-row>
      <el-radio-group v-model="tabCurrent" class="mb16" @change="$refs.list.handleRequest()">
        <el-radio-button label="toAudit">{{ $t('审核中') }}</el-radio-button>
        <el-radio-button label="pass">{{ $t('审核通过') }}</el-radio-button>
        <el-radio-button label="noPass">{{ $t('审核不通过') }}</el-radio-button>
      </el-radio-group>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          @query="handleSearch"
          :search-params="searchForm"
          :request-params="{type: 'creator', status: tabCurrent}"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column prop="num" :label="$t('序号')"/>

        <el-table-column prop="versionNum" :label="$t('头像')">
          <template v-slot="{row}">
            <preview-img :size="60" :img-url="row.portrait"/>
          </template>
        </el-table-column>
        .
        <el-table-column prop="userNickname" :label="$t('认证者昵称')"/>
        <el-table-column prop="username" :label="$t('认证者姓名')"/>
        <el-table-column prop="userNum" :label="$t('认证者编号')"/>
        <el-table-column prop="phone" :label="$t('手机号')"/>
        <el-table-column prop="idNum" :label="$t('身份证')"/>
        <el-table-column prop="createTime" :label="$t('创建时间')">
          <template v-slot="{row}">
            {{ row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" min-width="60">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="$router.push('audit?code=' + row.code)"
                       v-if="row.status === 'toAudit'">{{ $t('审核') }}
              </el-link>
              <el-link type="primary" :underline="false" @click="$router.push('detail?code=' + row.code)">{{ $t('查看') }}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{ $t('删除') }}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template slot="other">
      <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="resetForm">
        <template #title>
          <h4>{{ $t('批量审核') }}</h4>
        </template>

        <el-form label-width="auto" label-position="left" ref="form" :model="DialogFormData" :rules="rules">
          <el-form-item :label="$t('审核意见')" prop="status">
            <el-radio-group v-model="DialogFormData.status">
              <el-radio label="pass">{{ $t('通过') }}</el-radio>
              <el-radio label="noPass">{{ $t('不通过') }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('审核备注')" prop="auditRemark">
            <el-input v-model="DialogFormData.auditRemark" :placeholder="$t('请输入审核备注')" type="textarea" :rows="4"/>
          </el-form-item>
        </el-form>

        <template #footer>
          <el-button type="primary" @click="handleConfirm">{{ $t('确定') }}</el-button>
          <el-button @click="resetForm">{{ $t('重置') }}</el-button>
        </template>
      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "AuthList",
  components: {AnkhList, PreviewImg, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      tabCurrent: "toAudit",
      DialogFormData: {
        status: "pass",
        auditRemark: ""
      },
      showDialog: false,
      rules: {
        status: {required: true, message: this.$t('请选择审核状态'), trigger: 'blur'},
        auditRemark: {required: true, message: this.$t('请输入审核备注'), trigger: 'blur'}
      }
    }
  },
  methods: {

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.userAuth.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.userAuth.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.userAuth.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },
    handleBatchPass() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
      } else {
        let codes = this.selection.map(item => item.code);
        console.log(codes)
        this.showDialog = true;
      }

    },
    resetForm() {

      this.$refs.form.resetFields();
      this.DialogFormData.status = 'pass';
    },
    handleConfirm() {

      if (!this.selection.length) {
        return
      }
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        else {
          let params = this.selection.map(item => {
            return {
              "code": item.code, "status": this.DialogFormData.status, "auditRemark": this.DialogFormData.auditRemark
            }
          })
          console.log(params)
          await request(this.$api.userAuth.batchUpdateStatus, params,{isJson: true});
          this.$message.success(this.$t('操作成功'));
          this.showDialog=false;
          this.$refs.list.handleRequest();

        }

      })
    }


  },
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 450px;
  border-radius: 10px;
}
</style>
